import styled from 'styled-components';

export const StyledTableHeaderWithDate = styled.th`
  width: 6rem !important;
  min-width: 5.2rem !important;
  max-width: 10rem !important;
  padding: 0px !important;
`;
export const StyledSpot = styled.td`
  min-width: 80px !important;
  max-width: 80px !important;

  input {
    -moz-appearance: textfield; /* Firefox */
    appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      /* display: none; <- Crashes Chrome on hover */
      -webkit-appearance: none;
      margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }
  }
`;

export const StyledStrikeMode = styled.td`
  &,
  select {
    min-width: 3.5rem !important;
  }
`;

export const StyledStrikeDate = styled.td`
  width: 6rem !important;
  min-width: 5.2rem !important;
  max-width: 10rem !important;
`;
